/* eslint-disable react/prop-types */
import {
  Form, Input, Row, Col,
} from 'antd';
import { useEffect, useState } from 'react';
import {
  CountryDropdown, RegionDropdown,
  CountryRegionData,
} from 'react-country-region-selector';
import DownLogo from '../../assets/down_icon.svg';
import { getFirstRegion } from './const';

// https://github.com/country-regions/react-country-region-selector
// 获取指定国家的第一个state

export default function CompanyAddress({ countryData, stateData }) {
  const form = Form.useFormInstance();
  const [country, setCountry] = useState('');
  const [region, setRegion] = useState('');

  const handleChangeRegion = (val) => {
    form.setFieldValue('state', val);
    setRegion(val);
  };

  const handleChangeCountry = (val) => {
    form.setFieldValue('country', val);
    setCountry(val);
    const firstRegion = getFirstRegion(CountryRegionData, val);
    handleChangeRegion(firstRegion);
  };

  // const { country: countryData, state: stateData } = form.getFieldsValue();
  // console.log(countryData, stateData, 'countryData', props);
  useEffect(() => {
    handleChangeCountry(countryData);
    handleChangeRegion(stateData);
  }, [countryData, stateData]);
  // const [regionOptions, setRegionOptions] = useState([]);

  // const countryData = form.getFieldValue('country');
  // const handleCountryChange = (v) => {
  //   form.setFieldValue('state', undefined);
  //   setRegionOptions(getRegions(v));
  // };
  // useEffect(() => {
  //   setRegionOptions(getRegions(countryData));
  // }, [countryData]);

  return (
    <div>
      <Form.Item label="Street" name="street">
        <Input />
      </Form.Item>
      <Form.Item label="Apartment, suite, etc. (optional)" name="apartment">
        <Input />
      </Form.Item>
      <Form.Item label="City" name="city">
        <Input />
      </Form.Item>
      <Row gutter={16}>
        <Col span="8">
          <Form.Item label="Country/region" name="country">
            <CountryDropdown
              value={country}
              onChange={(val) => handleChangeCountry(val)}
              id="country"
              name="country"
              valueType="short"
              classes="clear_style"
            />
          </Form.Item>
          <img src={DownLogo} alt="" className="country_region_down_icon" />
          {/* <select>
            {CountryRegionData.map((option, index) => (
              <option key={option[0]} value={option[1]}>
                {option[0]}
              </option>
            ))}
          </select>
          <Form.Item label="Country/region" name="country">
            <Select onChange={handleCountryChange}>
              {CountryRegionData.map((option, index) => (
                <Select.Option key={option[0]} value={option[1]} listHeight={600}>
                  {option[0]}
                </Select.Option>
              ))}
            </Select>
          </Form.Item> */}
        </Col>
        <Col span={8}>

          <Form.Item label="State" name="state">
            <RegionDropdown
              showDefaultOption={false}
              country={country}
              value={region}
              onChange={(val) => handleChangeRegion(val)}
              id="state"
              name="state"
              countryValueType="short"
              classes="clear_style"
            />
          </Form.Item>
          <img src={DownLogo} alt="" className="country_region_down_icon" />

          {/* <Form.Item shouldUpdate noStyle>
            {() => (
              <Form.Item label="State" name="state">
                <Select>
                  {regionOptions.map(
                    (option, index) => (
                      <Select.Option key={option} value={option}>
                        {option}
                      </Select.Option>
                    ),
                  )}
                </Select>
              </Form.Item>
            )}

          </Form.Item> */}
        </Col>
        <Col span={8}>

          <Form.Item label="Postal code" name="postalCode">
            <Input />
          </Form.Item>
        </Col>
      </Row>

    </div>
  );
}
